export default "__VITE_ASSET__DeKG6sm___"